/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const StatFile = (props: { className?: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
    <path d="M0,0H19V19H0Z" fill="none" />
    <path
      d="M8.778,5.75h1.444v7.5H8.778Zm2.889,3h1.444v4.5H11.667Zm-5.778,1.5H7.333v3H5.889ZM11.667,3.5H4.444v12H14.556v-9H11.667ZM3,2.744A.733.733,0,0,1,3.722,2h8.667L16,5.75V16.245a.737.737,0,0,1-.717.755H3.717A.736.736,0,0,1,3,16.256Z"
      fill="currentColor"
    />
  </svg>
);

export { StatFile };
